import styled from 'styled-components';

import { media } from 'style-utils';

export const ColumnContainer = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Column = styled.div`
  position: relative;
  padding: 0 20px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  ${media.mobileTablet`
    padding: 0;
  `}
`;

export const ColumnSmall = Column.extend`
  width: 40%;
  ${media.mobileTablet`
    width: 100%;
  `}
`;

export const ColumnLarge = Column.extend`
  width: 60%;
  ${media.mobileTablet`
    width: 100%;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/layouts/Columns.js